import React, {useEffect, useState}					from 'react';

import Input										from '../ressources/components/Input';
import Icon											from '../ressources/components/Icon';
import Modal										from '../ressources/components/Modal';
import Checkbox										from '../ressources/components/Checkbox';
import Button										from '../ressources/components/Button';
import Tabs											from '../ressources/components/Tabs';
import {SelectData}									from '../ressources/components/Select/interface';
import ButtonStickyContainer						from '../ressources/components/Button/ButtonStickyContainer';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {deleteAddressApi, setMainAddressApi,
	postAddressApi,
	putAddressApi}									from '../redux/address/address';
import {Address, PutAddressData}					from '../redux/address/interface';
import {InputValues}								from '../ressources/components/Input/interface';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';

import img_dotsVertical								from '../ressources/images/icon/dots-vertical.svg';
import img_settings									from '../ressources/images/icon/menu/settings.svg';
import img_leftArrow								from '../ressources/images/icon/arrow/left.svg';
import img_plus										from '../ressources/images/icon/plus-square.svg';
import img_alertCircle								from '../ressources/images/icon/alert-circle.svg';

import LANGUAGE										from '../ressources/language';


interface Props {
	modal?: boolean,
	isBilling?: boolean,
	onClose?: () => void,
	onConfirm?: (newAddress: string) => void,
	setMenu?: (newValue: string) => void,
	initialValue?: string
}

function SettingsAddress(props: Props) {
	const dispatch = useAppDispatch();
	const address = useAppSelector(state => state.address.data);
	const load = useAppSelector(state => state.address.isLoadPut || state.address.isLoad);
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);
	const notificationId = useAppSelector(state => state.notifications.lastId);

	const [newMain, set_newMain] = useState(props.initialValue || '');

	const [modal, set_modal] = useState(false);
	const [name, set_name] = useState<InputValues>('');
	const [street, set_street] = useState<InputValues>('');
	const [complement, set_complement] = useState<InputValues>('');
	const [postalCode, set_postalCode] = useState<InputValues>('');
	const [city, set_city] = useState<InputValues>('');
	const [country, set_country] = useState<InputValues>('');
	const [firstname, set_firstname] = useState<InputValues>('');
	const [lastname, set_lastname] = useState<InputValues>('');
	const [phone, set_phone] = useState<InputValues>('');
	const [editData, set_editData] = useState<Address | undefined>(undefined);
	const [error, set_error] = useState<{[key: string]: string}>({});

	const TEXTE = LANGUAGE(lang);
	const MENU_DATA = [
		{value: 'main', render: TEXTE.settings.mainAddress},
		{value: 'mainBilling', render: TEXTE.settings.billingAddress}
	];
	const ACTIONS_LIST: SelectData[] = [
		{
			value:  'edit',
			render: <span className={'text-xs weight-500 gray-700'}>{TEXTE.settings.editAddress}</span>
		},
		{
			value:  'delete',
			render: <span className={'text-xs weight-500 error-600'}>{TEXTE.global.delete}</span>
		}
	];


	useEffect(() => {
		if (modal)
			return;
		set_name('');
		set_street('');
		set_complement('');
		set_postalCode('');
		set_city('');
		set_country('');
		set_firstname('');
		set_lastname('');
		set_phone('');
		set_editData(undefined);
	}, [modal]);

	useEffect(() => set_newMain(props.initialValue || ''), [props.isBilling]);

	function addOrEditAddress() {
		const newError: {[key: string]: string} = {};

		if (!name) newError.name = 'required';
		if (!street) newError.street = 'required';
		if (!postalCode) newError.postalCode = 'required';
		if (!city) newError.city = 'required';
		if (!country) newError.country = 'required';
		if (!firstname) newError.firstname = 'required';
		if (!lastname) newError.lastname = 'required';
		if (!phone) newError.phone = 'required';

		set_error(newError);

		if (Object.keys(newError).length > 0)
			return;

		const apiData: PutAddressData = {
			name,
			street,
			complement,
			postalCode,
			city,
			country,
			firstname,
			lastname,
			phone
		};

		dispatch(editData ? putAddressApi({idAddress: editData._id, data: apiData, user}) : postAddressApi({data: apiData, user}))
		.then(() => {
			const notification = ft_genNotification(TEXTE, editData ? 'editAddressSuccess' : 'addAddressSuccess', img_settings, name as string);
			ft_pushNotification(dispatch, notificationId, notification);

			set_modal(false);
		});
	}

	function editMainAddress() {
		if (!newMain)
			return props.onClose ? props.onClose() : null;

		dispatch(setMainAddressApi({
			user,
			idAddress: newMain,
			dataName:  props.isBilling ? 'billingMain' : 'main'
		}))
		.then(() => {
			const notification = ft_genNotification(TEXTE, props.isBilling ? 'editBillingAddressSuccess' : 'editMainAddressSuccess', img_settings);
			ft_pushNotification(dispatch, notificationId, notification);
			set_newMain('');

			if (props.onClose)
				return props.onClose();
		});
	}

	function deleteAddress(addressData: Address) {
		if (address.length === 1)
			return;
		dispatch(deleteAddressApi({idAddress: addressData._id, user}))
		.then(() => {
			const notification = ft_genNotification(TEXTE, 'deleteAddressSuccess', img_settings, addressData.name);
			ft_pushNotification(dispatch, notificationId, notification);

			if (newMain === addressData._id)
				set_newMain('');
		});
	}

	function setEditData(addressData: Address) {
		if (!addressData)
			return;
		set_name(addressData.name);
		set_street(addressData.street);
		set_complement(addressData.complement);
		set_postalCode(addressData.postalCode);
		set_city(addressData.city);
		set_country(addressData.country);
		set_firstname(addressData.firstname);
		set_lastname(addressData.lastname);
		set_phone(addressData.phone);
		set_editData(addressData);
		set_modal(true);
	}

	function renderAddress() {
		const render: React.ReactElement[] = [];

		address?.forEach((addressData) => {
			let foundError = false;
			let active = false;

			if (newMain && newMain === addressData._id)
				active = true;
			else if (!newMain && !props.isBilling && addressData.main)
				active = true;
			else if (!newMain && props.isBilling && addressData.billingMain)
				active = true;

			if (!addressData.firstname || !addressData.lastname || !addressData.street || !addressData.postalCode || !addressData.city)
				foundError = true;

			render.push(
				<div
					data-error={foundError}
					className={'settingAddressItem'}
				>
					<div onClick={() => !foundError && set_newMain(addressData._id)}>
						{foundError ?
							<Icon
								icon={img_alertCircle}
								popup={TEXTE.settings.incompleteAddress}
							/>
							:
							<Checkbox round active={active} />
						}
					</div>
					<div className={'settingAddressItemText'} onClick={() => !foundError && set_newMain(addressData._id)}>
						<span>{addressData.name}</span>
						<span>{`${addressData.street || ''}, ${addressData.postalCode || ''} ${addressData.city || ''}`}</span>
						{addressData.complement && <span>{addressData.complement}</span>}
						<span>{addressData.country}</span>
						<span>{`${addressData.firstname || ''} ${addressData.lastname || ''} ${addressData.phone || ''}`}</span>
					</div>
					<div className={'settingAddressItemIcon'}>
						<Button
							absoluteRight
							absoluteHideIcon
							type={'tertiary-gray'}
							absolute={ACTIONS_LIST}
							onChangeAbsolute={(action) => {
								if (action === 'delete')
									return deleteAddress(addressData);
								return setEditData(addressData);
							}}
						>
							<Icon icon={img_dotsVertical} />
						</Button>
					</div>
				</div>
			);
		});

		return (
			<div className={'deviceModalAssignUser'}>
				<div className={'deviceModalAssignUserBody'}>
					{render}
				</div>
			</div>
		);
	}

	function renderModalForm() {
		return (
			<Modal
				modalRight
				headerSeparation
				confirmLoad={load}
				confirmButton={() => addOrEditAddress()}
				confirmButtonText={TEXTE.global.validAndSave}
				onClose={() => set_modal(false)}
				header={editData ? TEXTE.settings.editAddress : TEXTE.settings.addAddress}
			>
				{props.modal &&
					<div className={'settingsAddressBackToList'} onClick={() => set_modal(false)}>
						<Icon icon={img_leftArrow} />
						{TEXTE.settings.backToList}
					</div>
				}

				<div className={'settingsAddressAddModal'}>
					<Input
						required
						value={name}
						onChange={set_name}
						error={error.name}
						title={TEXTE.settings.addressName}
					/>
					<Input
						required
						value={street}
						onChange={set_street}
						error={error.street}
						placeholder={TEXTE.settings.street}
						title={TEXTE.global.deliveryAddress}
					/>
					<Input
						value={complement}
						onChange={set_complement}
						placeholder={TEXTE.settings.complement}
					/>
					<Input
						required
						value={postalCode}
						onChange={set_postalCode}
						error={error.postalCode}
						placeholder={TEXTE.settings.postalCode}
					/>
					<Input
						required
						value={city}
						onChange={set_city}
						error={error.city}
						placeholder={TEXTE.settings.city}
					/>
					<Input
						required
						value={country}
						onChange={set_country}
						error={error.country}
						placeholder={TEXTE.settings.country}
					/>
					<Input
						required
						title={TEXTE.global.deliveryContact}
						value={firstname}
						onChange={set_firstname}
						error={error.firstname}
						placeholder={TEXTE.global.firstname}
					/>
					<Input
						required
						value={lastname}
						onChange={set_lastname}
						error={error.lastname}
						placeholder={TEXTE.global.lastname}
					/>
					<Input
						required
						value={phone}
						onChange={set_phone}
						error={error.phone}
						placeholder={TEXTE.global.phone}
					/>
				</div>
			</Modal>
		);
	}

	if (props.modal) {
		if (modal)
			return renderModalForm();

		return (
			<Modal
				size={482}
				modalRight
				headerSeparation
				confirmLoad={load}
				cancelButton={() => set_modal(true)}
				cancelButtonText={TEXTE.settings.newAddress}
				confirmButtonText={TEXTE.global.validAndSave}
				onClose={() => (props.onClose ? props.onClose() : null)}
				confirmButton={() => (props.onConfirm ? props.onConfirm(newMain) : editMainAddress())}
				header={props.isBilling ? TEXTE.settings.billingAddress : TEXTE.settings.mainAddress}
			>
				{renderAddress()}
			</Modal>
		);
	}

	return (
		<div className={'globalDataContainer'}>
			<div className={'globalDataContainerItem column'}>
				<Tabs
					button
					alignLeft
					data={MENU_DATA}
					actual={props.isBilling ? 'mainBilling' : 'main'}
					onChange={val => (props.setMenu ? props.setMenu(val as string) : undefined)}
				/>

				{renderAddress()}
			</div>

			<ButtonStickyContainer>
				<Button
					fullWidth
					type={'tertiary-gray'}
					onClick={() => set_modal(true)}
					iconBefore={img_plus}
				>
					{TEXTE.settings.addAddress}
				</Button>
				<Button
					fullWidth
					disabled={!newMain}
					onClick={() => editMainAddress()}
				>
					{TEXTE.global.saveChange}
				</Button>
			</ButtonStickyContainer>

			{modal && renderModalForm()}
		</div>
	);
}

export default SettingsAddress;
